<template>
  <section id="formulario" class="bg-[#57af4e] p-6 plex-regular">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700"
      @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto max-w-7xl bg-white bg-opacity-85 rounded-lg p-6">

        <div class="w-full py-6">
          <h1 class="plex-semibold text-xl text-gray-800">INSTITUCIONES</h1>
          <h1 class="plex-semibold text-gray-800">Por favor complete el formulario en su totalidad</h1>
        </div>

        <!-- Coordinator Data -->
        <h2 class="plex-semibold mt-5 w-full bg-white bg-opacity-55 p-2 rounded-lg border border-green-100">Coordinador
        </h2>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Documento</label>
            <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Documento"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="dni" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Empresa / Institución</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Empresa / Institución"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="empresa" />
              </span>
            </Field>
          </div>
        </div>
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Nombre"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="nombre" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Apellido"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="apellido" />
              </span>
            </Field>
          </div>
        </div>

        <!-- Students Data -->
        <h2 class="plex-semibold mt-5 w-full bg-white bg-opacity-55 p-2 rounded-lg border border-green-100">Integrantes
        </h2>

        <div v-for="(alumno, index) in formData.alumnos" :key="index"
          class="p-4 border rounded-lg mt-3 bg-gray-50 relative shadow-lg">
          <button type="button" @click="removeAlumno(index)"
            class="absolute top-2 right-2 text-red-600 hover:text-red-800 font-bold">
            <i class="pi pi-times"></i>
          </button>

          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
            <div class="w-full px-2 md:w-4/12">
              <label class="block mb-1">Documento</label>
              <Field :name="`alumnos[${index}].dni`" v-slot="{ field, errors }" v-model="alumno.dni">
                <InputText v-bind="field" type="text" class="input-base" placeholder="Documento"
                  :class="{ 'bg-white': true, 'input-error': errors.length > 0 }" />
                <span class="text-sm text-red-500 p-error">
                  <ErrorMessage :name="`alumnos[${index}].dni`" />
                </span>
              </Field>
            </div>
            <div class="w-full px-2 md:w-4/12">
              <label class="block mb-1">Nombre</label>
              <Field :name="`alumnos[${index}].nombre`" v-slot="{ field, errors }" v-model="alumno.nombre">
                <InputText v-bind="field" type="text" class="input-base" placeholder="Nombre"
                  :class="{ 'bg-white': true, 'input-error': errors.length > 0 }" />
                <span class="text-sm text-red-500 p-error">
                  <ErrorMessage :name="`alumnos[${index}].nombre`" />
                </span>
              </Field>
            </div>
            <div class="w-full px-2 md:w-4/12">
              <label class="block mb-1">Apellido</label>
              <Field :name="`alumnos[${index}].apellido`" v-slot="{ field, errors }" v-model="alumno.apellido">
                <InputText v-bind="field" type="text" class="input-base" placeholder="Apellido"
                  :class="{ 'bg-white': true, 'input-error': errors.length > 0 }" />
                <span class="text-sm text-red-500 p-error">
                  <ErrorMessage :name="`alumnos[${index}].apellido`" />
                </span>
              </Field>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <button type="button" @click="addAlumno" class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">
            <i class="pi pi-plus mr-2"></i> AGREGAR INTEGRANTE
          </button>
        </div>


        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit"
            class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i> REGISTRARME
          </button>
        </div>
      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>
</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';

import suiteService, { Acreditado, OrigenAcreditado, TipoAcreditado } from 'qreventos-suite/services';
import { SAVE, ORIGEN_ACREDITADO } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';

interface Alumno {
  nombre: string;
  apellido: string;
  dni: string;
}

export default defineComponent({
  name: 'FormColegio',
  components: {
    InputText,
    Field, ErrorMessage, Form, BlockUI
  },
  data() {
    return {
      isSubmitting: false,
      formData: {
        dni: '',
        nombre: '',
        apellido: '',
        empresa: '',
        alumnos: [] as Alumno[]
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required("Debe ingresar el DNI").min(6, "Al menos 6 caracteres"),
        nombre: yup.string().required("Debe ingresar el nombre").min(3, "Al menos 3 letras"),
        apellido: yup.string().required("Debe ingresar el apellido").min(3, "Al menos 3 letras"),
        empresa: yup.string().required("Debe ingresar la empresa").min(3, "Al menos 3 letras"),
        alumnos: yup.array().of(
          yup.object().shape({
            dni: yup.string().required("Debe ingresar el DNI").min(6, "Al menos 6 caracteres"),
            nombre: yup.string().required("Debe ingresar el nombre").min(3, "Al menos 3 letras"),
            apellido: yup.string().required("Debe ingresar el apellido").min(3, "Al menos 3 letras")
          })
        )
      });
    },
  },
  methods: {
    addAlumno() {
      this.formData.alumnos.push({ nombre: '', apellido: '', dni: '' });
    },
    removeAlumno(index: number) {
      this.formData.alumnos.splice(index, 1);
    },
    async hideSubmit() {
      this.isSubmitting = false;
      await this.$nextTick();
    },
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: "Revise el formulario<br>Hay " + errores + " error/es", icon: "error" });
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {
        let acreditadoExistente: Acreditado[] = await suiteService.findAcreditadosByFilters(suiteConfig.evento, "dni=" + encodeURIComponent(this.formData.dni));
        if (acreditadoExistente.length > 0) {
          await this.hideSubmit();
          Swal.fire({ title: "¡Atención!", html: "Ya existe un acreditado con el DNI ingresado", icon: "warning" });
          return;
        }

        // Coordinator
        const coordinador: Acreditado = {} as Acreditado;
        coordinador.tipoAcreditado = { "id": 2262 } as TipoAcreditado;
        coordinador.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
        coordinador.dni = this.formData.dni;
        coordinador.nombre = this.formData.nombre;
        coordinador.apellido = this.formData.apellido;
        coordinador.empresa = this.formData.empresa; // Institution
        coordinador.cantidad = 1;
        coordinador.notificar = true;
        coordinador.modificado = SAVE;

        const acreditadosParaGuardar: Acreditado[] = [coordinador];

        // Students
        this.formData.alumnos.forEach(alumno => {
          const accAlumno: Acreditado = {} as Acreditado;
          accAlumno.tipoAcreditado = { "id": 2261 } as TipoAcreditado;
          accAlumno.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
          accAlumno.dato15 = alumno.dni;
          accAlumno.nombre = alumno.nombre;
          accAlumno.apellido = alumno.apellido;
          accAlumno.empresa = this.formData.empresa;
          accAlumno.dato16 = this.formData.dni;
          accAlumno.cantidad = 1;
          accAlumno.notificar = false;
          accAlumno.modificado = SAVE;
          acreditadosParaGuardar.push(accAlumno);
        });

        const acreditadosResultado = await suiteService.saveOrUpdateAll(suiteConfig.evento, acreditadosParaGuardar);

        if (acreditadosResultado) {
          await this.hideSubmit();
          Swal.fire({ title: "¡Atención!", html: "Registro completado correctamente", icon: "success" }).then(() => {
            this.$router.go(0);
          });
        }
      } catch (error) {
        await this.hideSubmit();
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        await this.hideSubmit();
      }
    },
  }
});
</script>
